import React from "react";
import styled from "styled-components";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import { WSFormGrid } from "../../../WSUtils/WSFormGrid";
import { CVEditAddressSegment } from "./CVEditAddressSegment";
import { CVEditContactSegment } from "./CVEditContactSegment";
import { CVEditOtherDetailsSegment } from "./CVEditOtherDetailsSegment";
import { CVEditPersonaliaSegment } from "./CVEditPersonaliaSegment";
import { CVEditPositionWishesSegment } from "./CVEditPositionWishesSegment";

export const CVEditDetailsStep = withWSErrorContainer(() => {
  return (
    <CVEditDetailsStepStyles
      margin="1.15rem"
      float
      className="cve-details-step cve-step"
    >
      <CVEditPersonaliaSegment />
      <CVEditContactSegment />
      <CVEditAddressSegment />
      <CVEditPositionWishesSegment />
      <CVEditOtherDetailsSegment />
    </CVEditDetailsStepStyles>
  );
});

const CVEditDetailsStepStyles = styled(WSFormGrid)`
  &.cve-details-step {
    max-width: 520px;
    margin-top: 0;
  }
`;
